<template>
    <div>
        <b-row class="content-header">
            <b-col class="content-header-left mb-2" cols="12" md="9">
                <b-row class="breadcrumbs-top">
                    <b-col cols="12">
                        <h2>Terms of Use</h2>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-card>
            <h5>1. Acceptance of Terms</h5>
            <p>
                By accessing or using the services provided on leechall.io (the
                "Service"), you agree to comply with and be bound by these Terms
                of Service (the "Terms"). If you do not agree to these Terms,
                you must immediately cease using the Service.
            </p>

            <h5>2. Nature of the Service</h5>
            <p>
                The Service operates solely as a technical tool that enables
                users to generate download links for content hosted on
                third-party platforms. We do not host, store, or distribute any
                content on our servers.
            </p>
            <ul>
                <li>
                    <strong>Content Control:</strong> We do not control, host,
                    or verify any of the content hosted on third-party
                    platforms, and we make no guarantee about the legality,
                    availability, or safety of such content.
                </li>
                <li>
                    <strong>No Content Ownership:</strong> All files remain the
                    property of their respective owners. You are solely
                    responsible for ensuring you have the proper rights to
                    access and download any content.
                </li>
                <li>
                    <strong>Service Modifications:</strong> We reserve the right
                    to modify, suspend, or discontinue any part of the Service
                    at any time, without notice, at our sole discretion.
                </li>
            </ul>

            <h5>3. User Responsibilities</h5>
            <p>By using the Service, you agree that:</p>
            <ul>
                <li>
                    <strong>Full Responsibility:</strong> You are solely
                    responsible for all actions performed through your account,
                    including but not limited to downloading, accessing, or
                    sharing content. You assume all risks associated with the
                    use of the Service, including legal risks and any
                    consequences arising from the use of third-party content.
                </li>
                <li>
                    <strong>Compliance with Laws:</strong> You agree to comply
                    with all applicable laws, including but not limited to
                    copyright, intellectual property laws, and any other local,
                    national, or international laws relevant to your
                    jurisdiction.
                </li>
                <li>
                    <strong>Content Usage:</strong> You acknowledge that the
                    Service is not responsible for ensuring the legality,
                    safety, or appropriateness of any content you access via the
                    Service. All downloads, accesses, or uses of third-party
                    content are at your own risk.
                </li>
                <li>
                    <strong>Indemnity:</strong> You agree to indemnify, defend,
                    and hold harmless leechall.io, its operators, affiliates,
                    and partners against any claims, damages, losses,
                    liabilities, or expenses arising from your use of the
                    Service, including any legal actions stemming from the
                    content you access or download.
                </li>
            </ul>
            <p>
                <strong>Important Notice:</strong> By using the Service, you
                assume full responsibility for any legal consequences or damages
                resulting from your access to or use of third-party content.
            </p>

            <h5>4. User Accounts</h5>
            <ul>
                <li>
                    <strong>Personal Use Only:</strong> Accounts are for
                    personal use only and non-transferable. Sharing your account
                    or allowing unauthorized access is strictly prohibited.
                </li>
                <li>
                    <strong>Account Security:</strong> You are responsible for
                    maintaining the confidentiality of your login credentials
                    and for any activities that occur under your account. You
                    must immediately notify us of any unauthorized access to
                    your account.
                </li>
                <li>
                    <strong>Account Monitoring:</strong> We reserve the right to
                    monitor account activity for security purposes and to
                    prevent abuse or violations of these Terms.
                </li>
            </ul>

            <h5>5. Content Usage and Restrictions</h5>
            <ul>
                <li>
                    <strong>No Hosting or Distribution:</strong> The Service
                    does not host, store, or distribute any files. It solely
                    acts as a proxy for generating download links for content
                    hosted on third-party platforms.
                </li>
                <li>
                    <strong>Download at Your Own Risk:</strong> By using the
                    Service to generate download links or access any content,
                    you acknowledge and agree that you do so at your own risk.
                    We are not responsible for the legality, accuracy, or safety
                    of the content you download or access.
                </li>
                <li>
                    <strong>Illegal and Copyrighted Content:</strong> The
                    download or use of illegal, pirated, or copyrighted content
                    without proper authorization is strictly prohibited. It is
                    your responsibility to ensure that you have the proper
                    rights to download and use any content before accessing it.
                </li>
                <li>
                    <strong>Download Links Expiration:</strong> Download links
                    generated by the Service may expire, be blocked, or fail
                    without notice. We do not guarantee the availability,
                    reliability, or uptime of any specific download link.
                </li>
            </ul>

            <h5>6. Infringements</h5>
            <p>You agree not to:</p>
            <ul>
                <li>
                    <strong>Disrupt the Service:</strong> You will not disrupt
                    or interfere with the operation of the Service, including
                    attempting to bypass security measures or cause harm to the
                    Service infrastructure.
                </li>
                <li>
                    <strong>Reproduce or Distribute Content:</strong> You will
                    not reproduce, distribute, or otherwise use any content from
                    the Service without explicit authorization from the
                    respective content owner.
                </li>
                <li>
                    <strong>Engage in Harmful Behavior:</strong> You will not
                    engage in any behavior that may harm the reputation,
                    functionality, or operation of the Service.
                </li>
            </ul>
            <p>
                Failure to comply with these Terms may result in the immediate
                suspension or termination of your account, without refund, and
                possible legal action if warranted.
            </p>

            <h5>7. Disclaimer of Responsibility for Content</h5>
            <ul>
                <li>
                    <strong>No Hosting or Storage:</strong> leechall.io does not
                    host, store, reproduce, or distribute any files. All
                    download links are generated solely at the request of the
                    user from external file hosting services.
                </li>

                <li>
                    <strong>User’s Legal Responsibility:</strong> You are solely
                    responsible for ensuring that any files you download via the
                    Service are legal, safe, and authorized for your use.
                </li>

                <li>
                    <strong>Copyright and Illegal Use:</strong> If you download
                    copyrighted or illegal material without authorization, you
                    do so entirely at your own risk. leechall.io disclaims all
                    liability for any copyright infringement, unlawful activity,
                    or damages that result from your use of the Service.
                </li>

                <li>
                    <strong>Indemnification:</strong> By using the Service, you
                    agree to indemnify and hold harmless leechall.io, its
                    operators, and affiliates from any claims, legal
                    proceedings, damages, or liabilities arising from your
                    access to or use of third-party content.
                </li>
            </ul>

            <h5>8. Security</h5>
            <ul>
                <li>
                    <strong>Account Sharing & Leeching:</strong> Any attempt to
                    share your account or engage in leeching activities will
                    result in the immediate and permanent suspension of your
                    account, without prior notice.
                </li>
                <li>
                    <strong>Monitoring:</strong> We reserve the right to monitor
                    activity for security purposes and to prevent misuse or
                    violations of these Terms.
                </li>
            </ul>

            <h5>9. Refund Policy</h5>
            <ul>
                <li>
                    <strong>No Refunds:</strong> All payments for Premium
                    accounts are final and non-refundable. Once your
                    subscription is activated, no refunds will be issued,
                    regardless of service availability or usage.
                </li>
                <li>
                    <strong>Service Availability:</strong> We do not guarantee
                    continuous or uninterrupted access to any third-party hosts
                    or content. The availability of the Service is subject to
                    the limitations and availability of external platforms,
                    which may change without notice.
                </li>
            </ul>

            <h5>10. Modifications to Terms of Service</h5>
            <p>
                We reserve the right to modify, update, or change these Terms at
                any time, without prior notice. Users are encouraged to review
                these Terms periodically. Continued use of the Service
                constitutes your acceptance of the modified Terms.
            </p>

            <h5>11. Miscellaneous</h5>
            <ul>
                <li>
                    <strong>No Warranty:</strong> The Service is provided "as
                    is" and "as available," with no warranties of any kind,
                    express or implied. We do not warrant that the Service will
                    be uninterrupted, secure, or error-free.
                </li>
                <li>
                    <strong>Limitation of Liability:</strong> To the maximum
                    extent permitted by law, we disclaim any liability for
                    direct, indirect, incidental, consequential, or punitive
                    damages arising from your use of the Service. This includes,
                    but is not limited to, loss of data, loss of profits, or any
                    other commercial or personal damages or losses.
                </li>
                <li>
                    <strong>Indemnification:</strong> You agree to indemnify and
                    hold harmless leechall.io, its operators, affiliates, and
                    partners from any claims, damages, losses, liabilities, or
                    expenses arising from your use of the Service.
                </li>
            </ul>

            <h5>12. Law and Jurisdiction</h5>
            <p>
                These Terms constitute the entire agreement between you and
                leechall.io regarding the use of the Service. These Terms shall
                be governed by generally accepted principles of international
                commercial law. Any disputes shall be resolved exclusively
                through binding arbitration, seated in a neutral location, under
                the Rules of the International Chamber of Commerce (ICC). The
                arbitration shall be conducted in English. The costs of
                arbitration, including administrative fees and arbitrators'
                compensation, shall be borne by the losing party, unless
                otherwise determined by the arbitral tribunal.
            </p>
        </b-card>
    </div>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
export default {
    components: {
        BRow,
        BCol,
        BCard,
    },
};
</script>
<style></style>
